<div *ngIf="element" id="chart">
    <apx-chart [series]="inside_table.series" [chart]="inside_table.chart" [plotOptions]="inside_table.plotOptions"
        [xaxis]="inside_table.xaxis" [stroke]="inside_table.stroke" [colors]="inside_table.colors"
        [fill]="inside_table.fill" [tooltip]="inside_table.tooltip" [legend]="inside_table.legend"></apx-chart>
</div>

